import { useEffect, useState } from "react";
import React from "react";
import useDashboard from "../../hooks/useDashboard";
import DayView from "./day-view";
import WeekView from "./week-view";
import MonthView from "./month-view";
import useCalendar from "../../hooks/calendar/useCalendar";
import BarberUnavailabilityModal from "../barber/barber-unavailabilty/barberUnAvailabilityModal";
import AddToCalendarModal from "./add-to-calendar-modal";
import AddAppointmentModal from "./add-appointment-modal";

import ItemDropdown from "../../components/ItemDropdown";

import { BookingStatus } from "../../components/BookingStatus";
import AlertMessage from "../../components/AlertMessage";
import Breadcrumb from "../../components/Breadcrumb";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
const Calendar = () => {
  const {
    view,
    setView,
    selectedDate,
    setSelectedDate,
    getAppointments,
    displayedAppointments,
    displayDate,
    next,
    previous,
    goToday,
    employeeColors,
    employees,
    selectedEmployees,
    toggleEmployeeSelection,
    unavailableEmployees,
    showModalShortcut,
    showModal,
    selectedDateSlot,
    closeModalShortcut,
    handleAddSelection,
    activeModal,
    unavailability,
    onCloseModalClick,
    onAddUnavailable,
    onAddAppointment,
    message,
    showMessage,
    setShowMessage,
  } = useCalendar();

  const getCalendar = () => {
    switch (view) {
      case "day":
        return (
          <DayView
            date={selectedDate}
            appointments={displayedAppointments}
            employeeColors={employeeColors}
            unavailableEmployees={unavailableEmployees}
            showModalShortcut={showModalShortcut}
          />
        );

      case "week":
        return (
          <WeekView
            date={selectedDate}
            appointments={displayedAppointments}
            employeeColors={employeeColors}
            unavailableEmployees={unavailableEmployees}
            showModalShortcut={showModalShortcut}
          />
        );

      case "month":
        return (
          <MonthView
            date={selectedDate}
            appointments={displayedAppointments}
            employeeColors={employeeColors}
            unavailableEmployees={unavailableEmployees}
            showModalShortcut={showModalShortcut}
          />
        );
    }
  };

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Calander" />
        <div
          className="card p-3 mt-3 mb-3
        "
        >
          <div className="row">
            <div className="col-12 col-md-3 col-lg-3 mb-2 ">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                inline
              />
              <div className="list-group mt-3 ">
                {employees.map((e) => (
                  <button
                    type="button"
                    className={`list-group-item list-group-item-action staff-member  ${selectedEmployees.includes(e.id) ? "active" : ""}`}
                    style={{
                      backgroundColor: employeeColors.find(
                        (emp) => emp.name === e.name,
                      )?.color,
                    }}
                    onClick={() => toggleEmployeeSelection(e.id)}
                  >
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      value=""
                      checked={selectedEmployees.includes(e.id)}
                    />
                    <label className="form-check-label" for="checkDefault">
                      {e.name}
                    </label>
                  </button>
                ))}
              </div>
            </div>
            <div className="col-12 col-md-9 col-lg-9 mb-10">
              <div className="row">
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-secondary "
                        onClick={previous}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-chevron-left"
                        >
                          <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                      </button>

                      <button
                        className="btn btn-outline-secondary "
                        onClick={next}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-chevron-right"
                        >
                          <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                      </button>
                      <button
                        className="btn btn-outline-primary"
                        onClick={goToday}
                      >
                        Today
                      </button>
                    </div>
                    <div className="d-flex justify-content-center">
                      {displayDate()}
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className={`btn ${view === "day" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setView("day")}
                      >
                        Day
                      </button>
                      <button
                        className={`btn ${view === "week" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setView("week")}
                      >
                        Week{" "}
                      </button>
                      <button
                        className={`btn ${view === "month" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setView("month")}
                      >
                        Month
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {showMessage && (
                    <AlertMessage
                      key={message.text}
                      setVisible={setShowMessage}
                      message={message.text}
                      type={message.type}
                      duration={4000}
                    />
                  )}
                </div>
                <div className="col-12"> {getCalendar()}</div>
                <AddToCalendarModal
                  showModal={showModal}
                  selectedSlot={selectedDateSlot}
                  onClose={closeModalShortcut}
                  onSelect={handleAddSelection}
                />
                <BarberUnavailabilityModal
                  isOpen={activeModal === "unavailability"}
                  onSave={onAddUnavailable}
                  onClose={onCloseModalClick}
                  mode={"add"}
                  source="calendar"
                  initialData={unavailability}
                />
                <AddAppointmentModal
                  isOpen={activeModal === "appointment"}
                  onClose={onCloseModalClick}
                  dateTime={selectedDateSlot}
                  barber={
                    employees.filter((emp) => emp.id == selectedEmployees[0])[0]
                  }
                  onSave={onAddAppointment}
                  existingAppointments={displayedAppointments}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Calendar;
